module.exports = __webpack_public_path__ + "img/d200808-1.5acf3390.jpg";